import { importAll } from "./utils/importImages";

const fournisseurs = importAll(
  require.context("./images/logo/marques", false, /\.(png|jpe?g|svg)$/)
);

function Fournisseurs() {

    return (
    <div className="fourni-client-container">
      <h2 className="fourni-client-title">Nos Fournisseurs</h2>
      <div className="fourni-client-grid">
        {fournisseurs.map((f) => (
          <div key={f.name} className="fourni-client-card">
            <img src={f.logo} alt={f.name} className="fourni-client-logo" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Fournisseurs;